<script setup>
import CInfiniteScrollProductItem from "@/Components/CInfiniteScrollProductItem.vue"
import {ref, watch} from "vue"
import {router} from "@inertiajs/vue3"

const props = defineProps({
    productList: Object,
    hasFilterModules: Boolean
})

const products = ref(props.productList.productData || [])
const currentPage = ref(parseInt(route().params?.page) || 1)
const lastPage = ref(parseInt(props.productList.pagination.lastPage))
const totalProducts = ref(parseInt(props.productList.pagination.total) || 0)
const loading = ref(false)
const hasMoreProducts = ref(currentPage.value < lastPage.value)

watch(() => products, (newValue) => {
    // isso resolve o problema de resetar products a cada nova página
    // porém causará um bug que vai resetar a página sempre que o sistema
    // carregar a primeira página durante um load da pagina anterior
    if (!route().params || route().params.page === undefined) {
        products.value = newValue.productList
    }
})

async function loadMore() {
    //seta empty quando não tiver registros para carregar
    if (currentPage.value === 0 || currentPage.value >= lastPage.value) {
        hasMoreProducts.value = false
        return
    }

    loading.value = true

    router.get(route(route().current(), {...route().params, page: ++currentPage.value}), {}, {
        preserveState: true,
        preserveScroll: true,
        onSuccess: (res) => {
            products.value.push(...res.props.productList.productData)

            // se for uma pagina sem resultados não renderizamos eles
            if (products.length === 0) {
                hasMoreProducts.value = false
                loading.value = false
                return
            }

            lastPage.value = parseInt(res.props.productList.pagination.lastPage)
            totalProducts.value = parseInt(res.props.productList.pagination.total)
            hasMoreProducts.value = currentPage.value < lastPage.value

            setTimeout(() => {
                loading.value = false
            }, 1000)
        },
    })
}
</script>

<template>
    <div class="overflow-visible" style="min-height: 400px">
        <v-row class="ma-0">
            <v-col v-for="(product, index) in products" class="position-relative" :style="{'z-index': products.length - index}"
                   :xs="hasFilterModules ? 6 : 12" :sm="hasFilterModules ? 6 : 4" :md="hasFilterModules ? 6 : 4" :lg="hasFilterModules ? 4 : 3"
                   :xl="hasFilterModules ? 3 : 2">
                <c-infinite-scroll-product-item :product="product" :can-view-stock="props.productList.canViewStock"
                                                :can-view-price="props.productList.canViewPrice"/>
            </v-col>
            <v-col v-if="products.length === 0">
                <v-sheet class="d-flex align-center justify-center" height="200">
                    <span>Nenhum resultado encontrado!</span>
                </v-sheet>
            </v-col>
        </v-row>

        <div v-if="products.length > 0" class="d-flex justify-center my-6">
            <v-btn
                v-if="hasMoreProducts"
                @click="loadMore"
                :loading="loading"
                :disabled="loading"
                style="border-radius: 10px"
                color="primary"
            >
                Mais produtos
            </v-btn>
            <div v-else class="text-center">
                {{ totalProducts }} produtos, sem mais resultados
            </div>
        </div>
    </div>
</template>